module.exports = __webpack_public_path__ + "img/SSWS_Glass_sword.cf3b83cf.png";